function applySwatches() {
  const buttons = document.querySelectorAll('.stockPicker');
  if (!buttons.length) {
    console.warn("⚠️ No .stockPicker buttons found.");
    return;
  }

  console.log("🎯 Applying swatches to .stockPicker buttons");

  buttons.forEach(button => {
    const cpqColor = button.dataset.cpqColor;
    if (!cpqColor) return;

    const match = window.gke?.variantSwatches?.find(v =>
      v.swatch &&
      v.swatch !== "null" &&
      v.color?.toLowerCase() === cpqColor.toLowerCase()
    );

    if (match) {
      button.style.backgroundImage = `url(${match.swatch})`;
      button.style.backgroundSize = 'cover';
      button.style.backgroundRepeat = 'no-repeat';
      button.style.backgroundPosition = 'center';
    }
  });
}

function waitForInitialSwatches(attempts = 10) {
  const buttons = document.querySelectorAll('.stockPicker');
  if (!buttons.length) {
    if (attempts > 0) {
      setTimeout(() => waitForInitialSwatches(attempts - 1), 300);
    } else {
      console.warn("⚠️ No swatches found after retries.");
    }
    return;
  }
  applySwatches();
}

document.addEventListener('DOMContentLoaded', () => {
  waitForInitialSwatches();
});

const colorContainer = document.querySelector('.color-picker');
if (colorContainer) {
  const observer = new MutationObserver(() => {
    console.log("🔄 DOM change detected — reapplying swatches");
    applySwatches();
  });

  observer.observe(colorContainer, {
    childList: true,
    subtree: true
  });
}

document.addEventListener("click", (e) => {
  if (e.target.closest('.color-picker button') || e.target.closest('.size-picker button')) {
    requestAnimationFrame(() => applySwatches());
  }
});
